import { render } from "./FooterSIC.vue?vue&type=template&id=3abc409f"
import script from "./FooterSIC.vue?vue&type=script&lang=js"
export * from "./FooterSIC.vue?vue&type=script&lang=js"

import "./FooterSIC.vue?vue&type=style&index=0&id=3abc409f&lang=css"

import exportComponent from "C:\\Users\\pawarawat\\Documents\\Vue\\WebServer_Vue_NameCardSouvenir\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__